import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
     selector: 'app-snack-bar-info',
     templateUrl: './snack-bar-info.component.html',
     styleUrls: ['./snack-bar-info.component.scss']
})
export class SnackBarInfoComponent implements OnInit {

     constructor(
          @Inject(MAT_SNACK_BAR_DATA) public data,
          private _snackRef: MatSnackBarRef<SnackBarInfoComponent>,
          private ren: Renderer2
     ) {
          setTimeout(()=>{
               let snackEl = document.getElementsByClassName('closeSnackBar').item(0);
               if(snackEl) {
                    ren?.listen(snackEl, 'click', ()=>this.dismiss())
               }
          })
     }

     ngOnInit(): void {
          if(!this.data?.msg || this.data?.msg == '') {
               this.dismiss();
          }
     }

     dismiss(){
          this._snackRef.dismiss();
     }

}
